import React from 'react';
import { Controller } from 'react-hook-form';

import { DateRange } from '../baseui/input';

interface IDateRangeInput {
	name: any;
	control: any;
	defaultValue: any;
	onChangeCallback?: any;
}

const DateRangeInput: React.FC<IDateRangeInput> = (props) => {
	const { name, control, defaultValue = [], onChangeCallback } = props;
	return (
		<Controller
			render={({ field: { onChange, value } }) => {
				return <DateRange onChangeCallback={onChangeCallback} {...props} value={value} onChange={onChange} />;
			}}
			control={control}
			name={name}
			defaultValue={defaultValue}
		/>
	);
};

export default DateRangeInput;
